app.controller('exerciseResult', function ($scope, $filter, $timeout, $log, $sce, breakpointsService, loginService, dataService, $http) {
    $scope.weight = '';
    $scope.repetitions = '';
    // $scope.weightUnit = 'kg';
    $scope.exercise = {};
    $scope.resultList = {};
    $scope.resultData = {};
    // resultData === lastResult
    $scope.calculation = {
        weight: '',
        weightUnit: 'kg',
        maxResult: '',
        repetitions: '',
        selectedResult: null,
        editFlag: false
    };

    $scope.calculateResult = function () {
        if ($scope.calculation.weight && $scope.calculation.repetitions && $scope.calculation.weightUnit && $scope.exercise.id) {
            $scope.handleSubmitted();
        }
    };

    $scope.convertDateTime = function(dateStr) {
        // return Date.parse(dateStr.date);
        var arr = dateStr.date.split(/[- :]/),
        date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
        return date;
    };

    $scope.roundResults = function(value) {
        let decimal = value - Math.floor(value);
        return decimal ? value.toFixed(1) : value;
    };

    $scope.modifyOptionVal = function() {
        $scope.optionVal = dataService.modifyOptionVal($scope.calculation.maxResult, $scope.calculation.weightUnit, 0, 1, 7);
    };

    $scope.resutDateChange = function() {
        // console.log($scope.resultList);
        // console.log($scope.calculation.selectedResult);
        $timeout( function(){ 
            $scope.resultData = $filter('filter')($scope.resultList, {id:$scope.calculation.selectedResult})[0];
            // console.log($scope.resultData);
            if ($scope.resultData) {
                $scope.setCalculationData();
            }
        }, 100);
    };

    $scope.setCalculationData = function() {
        $scope.calculation.weight = Math.round($scope.resultData.weight*100)/100;
        $scope.calculation.repetitions = $scope.resultData.repetitions;
        $scope.calculation.maxResult = $scope.calculation.weight*(36/(37-$scope.calculation.repetitions));
        if ($scope.calculation.weightUnit != 'kg') {
            $scope.weightUnitChange();
        }
    };

    $scope.weightUnitChange = function () {
        const ratio = $scope.calculation.weightUnit === 'kg' ? 0.453592 : 2.20462;
        $scope.calculation.weight = Math.round($scope.calculation.weight * ratio * 100) / 100;
        $scope.calculation.maxResult = $scope.calculation.weight*(36/(37-$scope.calculation.repetitions));
    };

    $scope.editResult = function() {
        $scope.calculation.editFlag = true;
    };

    $scope.updateResult = function () {
        // console.log($scope.calculation);
        // console.log($scope.resultData);
        if ($scope.calculation.weight && $scope.calculation.repetitions && $scope.calculation.weightUnit && $scope.resultData.id) {
            $scope.handleUpdated();
        }
    };

    $scope.handleSubmitted = function() {
        return $http({
            method: 'POST',
            url: '/_endpoint/exercises-result/save-form?render_mode=json',
            data: "weight=" + $scope.calculation.weight + "&weightUnit=" + $scope.calculation.weightUnit + "&repetitions=" + $scope.calculation.repetitions + "&exerciseId=" + $scope.exercise.id,
            responseType: 'json',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }).then(function (httpResponse) {
            if (httpResponse.data) {
                if (httpResponse.data.json) {
                    var savedResult = httpResponse.data.json.filter(x => x.exercise.id === $scope.exercise.id);
                    // if (savedResult.exercise.id == $scope.exercise.id) {
                        $scope.resultData = savedResult[0];
                        // $scope.calculation.weightUnit = 'kg';
                        $scope.calculation.maxResult = $scope.calculation.weight*(36/(37-$scope.calculation.repetitions));
                        // $scope.resultList.push($scope.resultData);
                        $scope.resultList = savedResult;
                        $scope.calculation.selectedResult = $scope.resultData.id;
                        
                        $scope.calculation = {
                            weight: $scope.calculation.weight,
                            weightUnit: $scope.calculation.weightUnit,
                            repetitions: $scope.calculation.repetitions,
                            maxResult: $scope.calculation.weight*(36/(37-$scope.calculation.repetitions)),
                            editFlag: false,
                            selectedResult: $scope.resultData.id
                        };

                    // }
                }
            }
        }).catch(function(httpError) {
            if (httpError.xhrStatus !== "abort") {
                $log.error(httpError);
            }
            if (httpError.status === 403) {
                if (loginService.isLoggedIn === false) {
                    loginService.redirectToLoginScreen(true);
                } else if (httpError.headers('x-profile-upgrade-url')) {
                    window.location.href = httpError.headers('x-profile-upgrade-url');
                }
            }

            throw new Error('An error occurred! Please try again later.');
        });
    };

    $scope.handleUpdated = function() {
        return $http({
            method: 'POST',
            url: '/_endpoint/exercise-result/edit/' + $scope.resultData.id + '?render_mode=json',
            data: "weight=" + $scope.calculation.weight + "&weightUnit=" + $scope.calculation.weightUnit + "&repetitions=" + $scope.calculation.repetitions,
            responseType: 'json',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }).then(function (httpResponse) {
            if (httpResponse.data) {
                if (httpResponse.data.json) {
                    var savedResult = httpResponse.data.json;
                    $scope.resultData = savedResult;
                    // Find and update object in resultList
                    var index = $scope.resultList.findIndex( record => record.id === savedResult.id);

                    if(index > -1){
                        $scope.resultList[index] = savedResult;
                    }
                    $scope.calculation = {
                        weight: $scope.calculation.weight,
                        weightUnit: $scope.calculation.weightUnit,
                        repetitions: $scope.calculation.repetitions,
                        maxResult: $scope.calculation.weight*(36/(37-$scope.calculation.repetitions)),
                        editFlag: false,
                        selectedResult: $scope.resultData.id
                    };
                }
            }
        }).catch(function(httpError) {
            if (httpError.xhrStatus !== "abort") {
                $log.error(httpError);
            }
            if (httpError.status === 403) {
                if (loginService.isLoggedIn === false) {
                    loginService.redirectToLoginScreen(true);
                } else if (httpError.headers('x-profile-upgrade-url')) {
                    window.location.href = httpError.headers('x-profile-upgrade-url');
                }
            }

            throw new Error('An error occurred! Please try again later.');
        });
    };

    
});